<!----------------------- Компонент особистого кабінету --------------------->
<template>
  <div id="person" :class="{ 'blurred': isBlurred }" v-if="form != null">
    <headtop ref="head" :personData="form" :withoutName="withoutName" @updateData="getData()" />

    <div class="main-div" v-if="form != null" ref="thisPerson">
      <div class="custom-container">
        <!--
            Уведомление которое помогает осознать что это за страница
        -->
        <div v-if="lang['startDescription'] && form.companies.length > 0 && startMessage === true"
          class="alert alert-warning" role="alert">
          <strong>{{ lang["startDescription"] }}</strong>
          <button class="closeStartDescription p-absolute" @click="closeStartMessage"
            :title="lang['closeStartDescription']">
            <span aria-hidden="true" class="icon-cancel-circle"></span>
          </button>
        </div>
        <!--
            Сортировка компаний
        -->
        <div class="d-flex companies">
          <h5 class="h5-500" :class="{ hidden: isSearchOpen }" v-if="form.companies.length >= 1">
            {{ lang['MyCompany'] }}
          </h5>


          <template v-if="form.companies.length > 1">
            <!--Поиск компаний-->
            <div class="companies-settings">
              <div class="company-search" :class="{ active: isSearchOpen }"
                v-if="form.companies.length > 5 && !sortList">
                <input v-model="searchString" type="text" ref="searchInput" class="form-control searchInput"
                  :placeholder="searchText" :aria-label="lang['Search']" />
                <div class="icon-cancel-circle clear-search p-absolute" :class="{ active: isSearchOpen }"
                  @click="startStopSearch">
                </div>
                <svg @click="startStopSearch" class="search-icon" :class="{ active: isSearchOpen }"
                  xmlns="http://www.w3.org/2000/svg" height="46px" width="46px" viewBox="0 -960 960 960" fill="#404C60">
                  <path
                    d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
                </svg>
              </div>

              <!-- <b-button class="searchbutton" v-if="form.companies.length > 5 && !sortList" variant="outline-primary"
              :class="{ hidden: isSearchOpen }" @click="startSearch">
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px"
                fill="#404C60">
                <path
                  d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
              </svg>
            </b-button> -->
              <b-button class="sortbutton" v-if="!sortList && !isSearchOpen" variant="outline-primary" :title="lang['changeTheOrder']"
                @click="changeCompaniesList">
                <!-- <img src="@/assets/saveSVG.svg" alt="Save Button" width="24px" /> -->
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-top: -3px;" height="30px" viewBox="0 -960 960 960"
                  width="30px" fill="#404C60">
                  <path
                    d="m280-120-43-43 86-86q-116 6-199.5-73.5T40-520q0-117 81.5-198.5T320-800h120v60H320q-92 0-156 64t-64 156q0 91 67 152.5T326-308l-89-89 43-43 160 160-160 160Zm240-40v-280h360v280H520Zm0-360v-280h360v280H520Zm60-60h240v-160H580v160Z" />
                </svg>
              </b-button>
              <!-- <b-button class="editbutton" v-if="!sortList" variant="outline-primary"
                @click="settingsDropdown">
                <img src="@/assets/editSVG.svg" alt="Edit Button" width="30px" />
              </b-button> -->
              <b-button v-if="sortList" @click="cancelChanges" class="rollBack" :title="lang['cancelChangeOrder']">
                <svg data-v-77c06740="" xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 1060"
                  width="24px" fill="#fff">
                  <path data-v-77c06740=""
                    d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z">
                  </path>
                </svg>
              </b-button>
              <b-button class="sortSave" v-if="sortList" variant="success" @click="saveCompaniesList"
                :title="lang['saveChangeOrder']">{{ lang['saveChangeOrder'] }}
              </b-button>
            </div>
          </template>
          <template v-else>
            <div class="companies-settings"></div>
          </template>
        </div>

        <!--Поиск компаний-->
        <!-- <div class="company-search" :class="{ active: isSearchOpen }" v-if="form.companies.length > 5 && !sortList">
          <input v-model="searchString" type="text" ref="searchInput" class="form-control searchInput"
            :placeholder="searchText" :aria-label="lang['Search']" />
          <div class="icon-cancel-circle clear-search p-absolute" :class="{ active: isSearchOpen }" @click="stopSearch">
          </div>
          <svg class="search-icon" :class="{ active: isSearchOpen }" xmlns="http://www.w3.org/2000/svg" height="22px"
            viewBox="0 -960 960 960" width="21px" fill="#404C60">
            <path
              d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
          </svg>
        </div>
        <div class="not-search-div d-flex" v-if="searchString !== '' && companiesList.length <= 0">
          <img src="@/assets/dragons/Dragon_5_400.png" class="cat-svg" alt="Surprise Image" />
          {{ lang["CompanyNotSearch"] }}
        </div> -->

        <!-- БЛОКИ КОМПАНИЙ -->
        <template v-if="form.companies.length > 0">
          <draggable class="row company-block d-flex" v-model="form.companies" v-bind="dragOptions">
            <div v-for="(item, index) in companiesList" :key="index">
              <div class="pos-style" ref="maincard" :class="{ 'blocked': item.blocked }"
                @click="goToCompany(item)">
                <!--:style="item.blocked ? 'background-color: #f8d5d6;' : 'background: #fafafa;'"-->
                <div class="d-flex">
                  <div class="image-container" :class="sortList ? 'sortedMode' : ''">
                    <img v-if="item.logo.length > 1" class="logoImg" :src="logoUrl + item.company_id + '/' + item.logo"
                      alt="logo">
                    <img v-else :src="defaultLogo" class="logoImg" alt="default logo">
                  </div>
                  <div class="desc-div" :class="sortList ? 'sortedMode' : ''">
                    <h6 class="company_h">{{ item.company_name }}<span v-if="isDeveloper"> [{{
                      item.company_server
                    }}]</span></h6>
                    <p class="description"
                      :style="item.company_description == '' ? { 'color': '#b7b6b6', 'font-size': '0.8rem' } : {}">
                      {{
                        item.company_description != '' ? item.company_description :
                          lang['NoDescriptionSpecified']
                      }}
                    </p>
                  </div>
                </div>
                <div v-if="item.date_of_create" :class="sortList ? 'sortedMode' : ''">
                  <p class="p-style">{{ lang['DateCreate'] + ' ' + item.date_of_create }}<br></p>
                </div>
                <p v-if="item.blocked" class="blocked-text">{{ lang['blockedCompany'] }}</p>
                <div :class="['buttonCard', 'd-flex', sortList ? 'sortedMode' : '']">

                  <button v-if="form.companies.length < 5" class="btn enter-company btn-info btn-success"
                    :class="item.blocked ? 'btn-secondary enter-company-blocked' : 'btn-success'"
                    :disabled="item.blocked">
                    <div class="text-div">{{ lang["EnterToCompany"] }}</div>
                    <div class="img-div">
                      <img src="../../assets/arrow_dark_grey.svg" class="img-arrow" alt="Img Arrow">
                    </div>
                  </button>

                  <!--Альтернативна логіка-->
                  <div v-else>
                    <b-dropdown split variant="success-outline" :text="lang['EnterToCompany']" class="enter-company"
                      @click.stop="goToCompany(item)">
                      <b-dropdown-item v-if="false" href="#" @click.stop="goToCompany(item, 'pos')">{{ lang["goToPOS"]
                      }}</b-dropdown-item>
                      <b-dropdown-item v-if="false" href="#" @click.stop="goToCompany(item, 'dashboard')">{{ lang["goToDashboard"]
                      }}</b-dropdown-item>
                      <b-dropdown-divider v-if="false"></b-dropdown-divider>
                      <b-dropdown-item href="#" @click.stop="toArchive(item)">{{ lang["toArchive"] }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--
                      Иконка с домиком еслю юзер сам создал компанию
                      Иконка БЛОК если юзера сделали не активным в админке SkyService
                  -->
                  <span v-if="!item.person_admin" class="company-icon p-absolute">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                      fill="#1f1f1f">
                      <path
                        d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" />
                    </svg>
                  </span>
                  <!--<span v-if="item.blocked" class="icon-blocked p-absolute"></span>-->
                </div>
                <div v-if="sortList" class="sortedIcon p-absolute"></div>
              </div>
            </div>
          </draggable>
        </template>
        <!--
            Если компаний нет
        -->
        <div v-else class="ghost-container d-flex">
          <div class="ghost-img">
            <img src="@/assets/dragons/Dragon_5_400.png" class="cat-svg" alt="Surprise Image" />
          </div>
          <div class="ghost-text d-flex">
            <h5>{{ lang["YouDontHaveCompanyYet"] }}!</h5>
            <div>
              <p class="noCompany-text"
                v-html="form.user.can_create_company ? lang['NoCompanyText'] : lang['NoCompanyCreateText']">
              </p>
            </div>
            <button v-if="form.user.can_create_company" class="btn btn-outline-dark buttonStartComp"
              @click="addCompany = !addCompany">{{ lang['CreateNewCompany'] }}
            </button>
            <button style="display: none;" v-if="form.invitations.length <= 0" class="btn btn-danger buttonStartComp"
              @click="goDemo">{{ lang['visitDemo'] }}
            </button>
          </div>
        </div>

        <!--Тут архівні компанії-->
        <div v-if="searchString == '' && archivedCompanies.length > 0">

          <div class="row" style="margin-top:25px; margin-bottom:15px; cursor: pointer;"
            @click="archivedCollapce = !archivedCollapce">
            <h5>{{ lang["Archived"] }}</h5>
            <img :class="archivedCollapce ? 'img-arrow-up' : 'img-arrow-down'" src="../../assets/arrow_dark_grey.svg"
              alt="Img Arrow" style="margin-left:10px">
          </div>

          <b-collapse v-model="archivedCollapce">
            <div class="row company-block d-flex">
              <div v-for="(item, index) in archivedCompanies" :key="index">
                <div class="pos-style" ref="maincard" :class="{ 'blocked': item.blocked }"
                  @click="goToCompany(item)">
                  <!--:style="item.blocked ? 'background-color: #f8d5d6;' : 'background: #fafafa;'"-->
                  <div class="d-flex">
                    <div class="image-container">
                      <img v-if="item.logo.length > 1" class="logoImg"
                        :src="logoUrl + item.company_id + '/' + item.logo" alt="logo">
                      <img v-else :src="defaultLogo" class="logoImg" alt="default logo">
                    </div>
                    <div class="desc-div">
                      <h6 class="company_h">{{ item.company_name }}<span v-if="isDeveloper"> [{{
                        item.company_server
                          }}]</span></h6>
                      <p class="description"
                        :style="item.company_description == '' ? { 'color': '#b7b6b6', 'font-size': '0.8rem' } : {}">
                        {{
                          item.company_description != '' ? item.company_description :
                            lang['NoDescriptionSpecified']
                        }}
                      </p>
                    </div>
                  </div>
                  <div v-if="item.date_of_create">
                    <p class="p-style">{{ lang['DateCreate'] + ' ' + item.date_of_create }}<br></p>
                  </div>
                  <p v-if="item.blocked" class="blocked-text">{{ lang['blockedCompany'] }}</p>
                  <div :class="['buttonCard', 'd-flex']">
                      <b-dropdown split variant="success-outline" :text="lang['EnterToCompany']" class="enter-company"
                        @click.stop="goToCompany(item)">
                        <b-dropdown-item v-if="false" href="#" @click.stop="goToCompany(item, 'pos')">{{ lang["goToPOS"]
                        }}</b-dropdown-item>
                        <b-dropdown-item v-if="false" href="#" @click.stop="goToCompany(item, 'dashboard')">{{ lang["goToDashboard"]
                        }}</b-dropdown-item>
                        <b-dropdown-divider v-if="false"></b-dropdown-divider>
                        <b-dropdown-item href="#" @click.stop="undoArchive(item)">{{ lang["undoArchive"] }}</b-dropdown-item>
                      </b-dropdown>
                    <!--
                          Иконка с домиком еслю юзер сам создал компанию
                          Иконка БЛОК если юзера сделали не активным в админке SkyService
                      -->
                    <span v-if="!item.person_admin" class="company-icon p-absolute">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#1f1f1f">
                        <path
                          d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <!--Кінець архівних компаній-->

        <!--
           Не знайшли компанію по пошуку
        -->
        <div v-show="searchString !== '' && companiesList.length <= 0 && searchString.toLowerCase() != 'dev'">
          <div class="not-search-div d-flex">
            <img src="@/assets/dragons/Dragon_5_400.png" class="cat-svg" alt="Surprise Image" />
            {{ lang["CompanyNotSearch"] }}
          </div>
        </div>
        <!--
           Кнопка создать новую компанию
        -->
        <div class="row" v-if="!isEmptySearch">
          <div class="span-container" v-if="form.companies.length >= 1 && form.user.can_create_company">
            <span class="add-company" @click="addCompany = !addCompany">{{ lang['CreateNewCompany'] }}</span>
          </div>
        </div>
        <!--
           Список инвайтов в компанию
        -->
        <div v-if="form.invitations.length >= 1 && !isEmptySearch">
          <h5 class="h5-501">
            {{ lang['Invites'] }}
          </h5>
          <div class="row company-invites-block d-flex company-block d-flex">
            <div v-for="(item, index) in form.invitations" :key="index">
              <div class="pos-style invites-accept" @click="acceptCompany(item)">
                <div class="d-flex">
                  <div class="image-container">
                    <img v-if="item.logo.length > 1" class="logoImg" :src="logoUrl + item.company_id + '/' + item.logo"
                      alt="logo">
                    <img v-else :src="defaultLogo" class="logoImg" alt="default logo">
                  </div>

                  <div class="invites-div-desc">
                    <h6 class="company_h">{{ item.company_name }}</h6>
                    <p class="description"
                      :style="item.company_description == '' ? { 'color': '#b7b6b6', 'font-size': '0.8rem' } : {}">
                      {{
                        item.company_description != '' ? item.company_description :
                          lang['NoDescriptionSpecified']
                      }}<br></p>
                  </div>
                </div>

                <div v-if="item.date_of_create">
                  <p class="p-style">{{ lang['DateCreate'] + ' ' + item.date_of_create }}<br></p>
                </div>
                <p v-if="item.blocked" class="blocked-text">{{ lang['blockedCompany'] }}</p>
                <div :class="['buttonCard', 'd-flex', sortList ? 'sortedMode' : '']">
                  <button v-if="lang['EnterToCompany']" class="btn btn-info btn-outline-dark enter-company"
                    :class="item.blocked ? 'btn-secondary enter-company-blocked' : 'btn-success'"
                    :disabled="item.blocked">
                    <div class="text-div">{{ lang["actions"] }}</div>
                    <div class="img-div">
                      <img src="../../assets/arrow_dark_grey.svg" class="img-arrow" alt="Img Arrow">
                    </div>
                  </button>
                  <!--
                      Иконка с домиком еслю юзер сам создал компанию
                      Иконка БЛОК если юзера сделали не активным в админке SkyService
                  -->
                  <span v-if="!item.person_admin" class="company-icon p-absolute"></span>
                  <!--<span v-if="item.blocked" class="icon-blocked p-absolute"></span>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Блок для разробників початок-->
        <div v-if="isDeveloper && searchString.toLowerCase() == 'dev'" class="row">
          <div v-if="!sortList" class="row developer-box company-block d-flex w-100">
            <div class="pos-style-developer" ref="devcard">
              <div class="d-flex">
                <div class="image-container">
                  <img :src="developerLogo" class="logoImg" alt="default logo">
                </div>
                <div class="desc-div">
                  <h6 class="company_h">Developer Mode</h6>
                  <p class="description">
                    <input type="text" v-model="developerURL">
                  </p>
                </div>
              </div>

              <div>
                <p class="p-style">Skyservice with concern for developers<br></p>
              </div>
              <div class="d-flex buttonCard">
                <button class="btn btn-info btn-outline-dark enter-company" @click="goToDeveloperURL()">
                  <div class="text-div">Go to URL</div>
                  <div class="img-div">
                    <img src="../../assets/arrow_dark_grey.svg" class="img-arrow" alt="Img Arrow">
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--Блок для разробників кінець-->
      </div>
    </div>
    <!--
        если у юзера отсутствует email при после прохождения регистрации
    -->
    <addemail v-if="showAddEmail" @close="showAddEmail = false, getData()" />
    <!--
        Принять или отклонить приглашение в компанию
    -->
    <acceptInvite v-if="showAcceptInvite" :companyData="companyData" @close="showAcceptInvite = false, getData()" />
    <!--
        Добавление компании, если вдруг у юзера нет пароля, там появляется кнопка настроек
    -->
    <addcompany v-if="addCompany"  @close="addCompany = false, getData()" :havePassword="form.user.have_password"
      @openSettings="openSettings" />
    <!--
        Создание компании при старте
    -->
    <wontCreateCompany v-if="wontCreateCompany" @close="wontCreateCompany = false" @goNext="goNext"
      @add_mail="addMailInStart" />
    <!--
        Добавить пароль
    -->
    <addPassword v-if="showAddPass" :userPhone="form.user.phone" :passwordText="lang['FirstCreateAnAccountPassword']" @close="showAddPass = false"
      @passwordReady="openModalSelector" /><!-- , getData() -->
    <!--
        Выбор роли
    -->
    <selectRole v-if="showSelectRole" @selectRole="selectRole" :form="form" />
    <!--
        Настройки
    -->
    <personsettings v-if="showSettings" @close="closeSettings" />
    <!--
        Компонент кнопки для вызова чата на старых андроидах
    -->
    <CrispChatButton v-if="showCrispButton" @close="showCrispButton = false" />
  </div>

  <div v-else-if="showLogin">
    <AuthModal :registered="true" @success="getData" />
  </div>
</template>

<script>
import { store } from '@/store.js';
import headtop from '../heads/Head.vue';
import addemail from './addEmail.vue';
import addcompany from './AddCompany.vue';
import acceptInvite from './acceptInvite.vue';
import personsettings from '../settings/PersonSettings.vue';
import draggable from 'vuedraggable';
// модалки которые нужны при старте юзера
import wontCreateCompany from './wontCreateCompany.vue';
import addPassword from '../settings/addPassword.vue';
import selectRole from './selectRole.vue';
import jsSearch from "@/components/jsSearch.js"
import CrispChatButton from "@/components/CrispChatButton.vue" // компонент нативной кнопки чата для старых андроидов
import AuthModal from '@/components/settings/authModal.vue';
import { webviewCheck } from '../js/webviewCheck.js';
import { ws } from '@/socket/websocket'
import { MoreURL } from "@/API.js";
import defaultLogo from "@/assets/default-logo.png";
import developerLogo from "@/assets/settings.png"

const moreURLs = new MoreURL()

//модуль управления куками
import Cookies from 'js-cookie'; // Модуль для роботи з кукі
// создаем апи куков с настройкой дэфолтного домена для продакшена
let apiCookies = Cookies;
if (process.env.NODE_ENV == 'production') {
  apiCookies = Cookies.withAttributes({ domain: ".skyservice.online" })
}

import { regAPi } from '@/API.js';

const apiList = new regAPi();


let developers = [
  'f2ab140d-f92c-47b2-8c64-b9dd3ab098d8', //Вадим Павлюк
  'c8b61143-16b1-47b5-9176-a12051e62159', //Сергей Волошин
  '20774647-8e97-4626-9bd4-3d4e326c3aa2', //Илья Олещенко
  'bf9e3616-d5e1-44e4-8761-9d838baa96c6', //Дима Ксенжук
  '7289e1c7-1e8a-4975-898a-965f1328d952', //Олег Куць
  'a48a43e0-7131-4b20-81e5-907c3d3507f0', //Юра Красота
  'bb1264a4-4a86-4d33-8b97-69aa5bcf78cc', //Дубовик Микола
  '70eada89-c43a-4735-b841-e4e3f0725c22', //Головань Максим
  '2bf99ad6-4687-4328-9aad-794894c1102a', //Головань Максим
  'ce9b8c1e-6e1c-42ee-a833-12e2c401693f', //Polina Mysiura
  'be567046-7e8e-440d-b8ec-b556273a1dd2', //Вадим Атаманюк
  '1ea2ec44-8a22-4502-807a-40c4f399d15d', //Богдан
  'fc9b7c2d-bb8f-4e30-b0c1-3b0a32b38025'  //Nastia Khaia
]

export default {
  name: 'Person',
  props: ['personData'],
  components: {
    addemail,
    addcompany,
    acceptInvite,
    headtop,
    personsettings,
    wontCreateCompany,
    addPassword,
    selectRole,
    draggable,
    CrispChatButton,
    AuthModal,
  },
  data() {
    return {
      logoUrl: 'https://files.skyservice.pro/uploads/images/',
      searchString: "",
      form: null,
      companyData: null,
      addCompany: false,
      withoutName: false,
      isSearchOpen: false,
      sortList: false,
      startMessage: true,
      wontCreateCompany: false,
      startLoader: false,
      showSettings: false,
      showAcceptInvite: false,
      showAddPass: false,
      showSelectRole: false,
      showAddEmail: false,
      showCrispButton: false,
      isDeveloper: false,
      developerURL: "http://localhost:1024",
      isBlurred: false,
      phrasesFlag: false,
      defaultLogo,
      developerLogo,
      archivedCollapce: false,
      archivedCompanies: [],
      showLogin: false,
    }
  },
  created() {
    //если стартовое сообщение уже закрывали то прячем его
    if (localStorage["closeStartMessage"]) {
      this.startMessage = false;
    }

    //Включать режим разработки
    if (localStorage["isdeveloper"] == 1) {
      this.isDeveloper = true;
    }

    //Берем сохраненную ссылку и вставляем в поле ввода
    if (localStorage["developerURL"]) {
      this.developerURL = localStorage["developerURL"];
    }

    if (webviewCheck() == "android_webview") {
      this.showCrispButton = true
    } else {
      // стартуем чат поддержки
      window.$crisp.push(['do', 'chat:show']);
    }
    //Адаптация чата для мобильно приложения ios iphone 10+
    //Определяем что за девайс, есть ли брова
    try {
      //Notch - вырез в экране айфона
      let isNotch = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sat"));
      if (isNotch > 0 && webviewCheck() == "ios_webview") {
        // Знаходимо перший елемент з атрибутом [data-mode][data-helpdesk-collapsed] (шапка чату) та задаємо стилі
        let firstElement = document.querySelector('.crisp-client #crisp-chatbox [data-mode][data-helpdesk-collapsed]');
        firstElement.parentElement.style = `padding-top: ${isNotch}px !important; background: #5db85b !important;`;
        // Задаємо стилі для елементу (тіла) чату
        document.querySelector('.crisp-client #crisp-chatbox [data-has-health][data-has-drop-zone][data-has-feedback] [data-visible]').style = `margin-bottom: ${isNotch}px !important;`
      }
    } catch (err) {
      console.log("нету моноброви");
    }
    // фикс для приложения почему-то скролилось ниже но в сафари не работает
    window.scrollTo(0, 0);

    // если юзер не авторизирован, перекидываем его на странице логина, если он авторизировался и получил токен, тогда вызываем getData
    console.log(store.token)
    if (!store.token && process.env.NODE_ENV == 'production') {
        document.location.href = 'https://auth.skyservice.online/';
      // редиректим на авторизацию
    } else {
      this.getData();

      // если юзер зарегался по рефералке, при входе в акк кикаем рефералку
      if (localStorage.getItem('ref_id') != null) {
        localStorage.removeItem('ref_id');
      }
      // проверяем, стартовала ли регистрация, если это его первый вход с реги, кикаем флаг
      if (localStorage.getItem('registration_start') != null) {
        localStorage.removeItem('registration_start');
      }
      // убираем почту или мыло когда юзер с логина перескакивал на регу
      if (localStorage.getItem('go_reg_phone') != null) {
        localStorage.removeItem('go_reg_phone');
      }
      if (localStorage.getItem('go_reg_mail') != null) {
        localStorage.removeItem('go_reg_mail');
      }
    }

  },

  methods: {
    settingsDropdown() {
      const s = document.querySelector('.dropdown-menu');
      s.classList.remove('show');
      this.showSettings = !this.showSettings;
    },
    startPrepareCompany(status) {
      if (status === 'end') {
        store.loaderText = '';
        store.loader = this.isBlurred = false;
        this.phrasesFlag = false;
        this.secondCallFlag = false;
        return;
      } else {
        this.phrasesFlag = true
        const outputPhrases = (index) => {
          let delay = index === 0 ? 2000 : 3000;
          if (index < this.phrasesArray.length) {
            store.loader = this.isBlurred = true;
            store.loaderText = this.phrasesArray[index];
            setTimeout(() => {
              outputPhrases(index + 1);
            }, delay);
          }
        };
        outputPhrases(0);
      }
    },
    goToDeveloperURL() {
      localStorage["developerURL"] = this.developerURL;
      document.location.href = this.developerURL;
    },
    closeStartMessage() { // закрыть стартовый алерт
      this.startMessage = false;
      localStorage["closeStartMessage"] = true;
    },
    goDemo() { // дємо компания
      location.href = moreURLs.goDemo(store.lang);
    },
    openModalSelector() { // открыть модалку выбора сотрудника\владельца
      if (this.form.invitations.length <= 0) {
        this.showSelectRole = true
      }
    },
    selectRole(obj) { // выбор сотрудника\владельца
      if (obj.accountType == "owner" && obj.createCompany == true) {
        this.showSelectRole = false
        this.startPrepareCompany('start')
      }
      apiList.accountType(obj).then(resp => {
        if (obj.accountType == "owner" && obj.createCompany == true) {
          document.location.href = resp.data.data;
          this.startPrepareCompany('end')
        } else {
          this.showSelectRole = false
          this.getData();
        }

      })
    },
    addMailInStart() { // добавляем почту пользователя
      if (this.form.email == '') {
        this.showAddEmail = true;
      }
    },
    goNext() { // при создании первой компании, сразу летим в неё
      try {
        // this.startLoader = true;
        apiList.companyStart({ token: store.token, lang: this.form.lang }).then(resp => {
          // this.startLoader = false;
          if (resp.data.status == 'done') {
            location.href = resp.data.data;
            // this.getData();
          } else {
            this.getData();
            window.say.messageError(this.lang['Error'])
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    closeSettings() { // Закрытие настроек
      this.withoutName = false
      this.showSettings = false;
      this.getData();
    },
    openSettings() { // открытие настроек
      this.showSettings = !this.showSettings;
    },
    toArchive(company) {
      console.log(company)
      apiList.toArchive(company.company_id).then(resp => {
        console.log(resp)
        this.getData();
      })
    },
    undoArchive(company) {
      console.log(company)
      apiList.undoArchive(company.company_id).then(resp => {
        console.log(resp)
        this.getData();
      })
    },
    // Тут при клике мы берем id компании, токен
    // отправляем это на БЭК
    // С БЭКА получаем сформированную ссылку и летим по ней в админку
    goToCompany(e, goto) {
      if (e.blocked) {
        window.say.messageError(this.lang['companyBlocked'])
      } else if (this.sortList) {
        console.log("В режиме сортировки вход в компанию не разрешен")
      } else {
        this.closeStartMessage();
        try {
          if (e.is_new) {
            console.warn(e)
            this.startPrepareCompany('start')
          }
          apiList.redirectPerson({ token: store.token, company_id: e.company_id }, goto).then(resp => {
            console.log(resp)
            if (e.is_new) {
              console.warn(e)
              this.startPrepareCompany('end');
            }
            if (resp.data.status == 'done') {
              // Костыльчик для старого сервиса
              // Скорей всего это решение идеально для интеграции -
              // со сторонними сервисами и более предпочтительное чем то что было до этого
              // Поскольку мы хотим знать где был последний раз клиент
              // и при следующем входе его туда обратно перебрасывать
              // то нам нужно запомнить в куки location
              // но сделать это так как мы сделали в новой админке не получится так как с
              // online.skyservice.pro у нас нету доступа к кукам .skyservice.online
              // по этому запоминаем куда мы перешли здесь в случае если это старый сервер
              if (e.company_server == "s-1") {
                let currentLocation = {
                  project: "online.skyservice.pro"
                };

                apiCookies.set("location", JSON.stringify(currentLocation), { expires: 180 })


                try {
                  let iosData = {
                    location: currentLocation
                  }
                  window.webkit.messageHandlers.saveUserData.postMessage(JSON.stringify(iosData));
                } catch (err) {
                  //Не приложение ios
                }


              }

              if (e.company_server == "s-5") {
                let currentLocation = {
                  project: "online2.skyservice.pro"
                };

                apiCookies.set("location", JSON.stringify(currentLocation), { expires: 180 })


                try {
                  let iosData = {
                    location: currentLocation
                  }
                  window.webkit.messageHandlers.saveUserData.postMessage(JSON.stringify(iosData));
                } catch (err) {
                  //Не приложение ios
                }

              }

              location.href = resp.data.data;
            } else if (resp.data.error == 'worker is inactive') {
              window.say.messageError(this.lang['youBlockedInComp']);
            } else {
              this.getData();
              window.say.messageError(this.lang['Error']);
            }
          })
        } catch (err) {
          window.say.messageError(this.lang['Error']);
        }
      }
    },
    acceptCompany(item) { // вызываем модалку принять/отклонить приглашение
      this.companyData = item;
      this.showAcceptInvite = !this.showAcceptInvite;
    },
    // Функция для установки пользовательских данных через Crisp
    setUserData(key, value) {
      try {
        if (value) {
          window.$crisp.push(["set", key, value]);
        }
      } catch (error) {
        // console.warn(error)
      }
    },
    getData() { // получаем данные по персоне
      try {
        this.showLogin = false
        apiList.getCompanies().then(resp => {
          if (resp.data.status == 'done') {
            if (resp.data) { // После получения данных о компании передаем их в чат
              if (webviewCheck() !== "android_webview") {

                const userData = resp.data.data.user;

                // Установка пользовательской электронной почты
                this.setUserData("user:email", userData.email);

                // Установка имени пользователя (если доступно, иначе используется значение по умолчанию)
                try {
                  const userName = userData.name ? userData.name : this.lang['withoutName'];
                  this.setUserData("user:nickname", userName);
                } catch (error) {
                  // console.error(error)
                }
                // Установка номера телефона
                this.setUserData("user:phone", userData.phone);

                // Установка страны пользователя
                this.setUserData("user:country", userData.country);

                // Установка идентификатора аккаунта
                this.setUserData("user:accountId", userData.accountId);
              }
            }
            this.form = resp.data.data;
            store.lang = this.form.lang;


            try {
              //Кто есть в списке тот и получает режим разработчика
              if (developers.includes(this.form.user.account_id)) {
                this.isDeveloper = true;
              }
            } catch (err) {
              console.error();
            }


            if (resp.data.data.user.country) {
              store.country = resp.data.data.user.country;
            }

            if (resp.data.data.user.IP) {
              store.IP = resp.data.data.user.IP;
            }

            //resp.data.data.user.account_id = "f2ab140d-f92c-47b2-8c64-b9dd3ab098d8"; //костыль временно для теста
            if (resp.data.data.user.account_id) {
              store.accountId = resp.data.data.user.account_id;
              //Подключение ВебСокета
              ws();
            }

            if (!this.form.user.name) {
              this.withoutName = true
              this.form.user.name = this.lang['withoutName']
            } else {
              this.withoutName = false
              this.form.user.name = resp.data.data.user.name
            }
            // добавляем в стор сразу рефералки
            store.ref = this.form.ref;
            // на всякий случай, вдруг юзер зашел через соц сеть с нового устройства, записываем его номер телефона
            if (this.form.user.phone != null) {
              localStorage.setItem('registration_phone', this.form.phone);
            }
            if (!this.form.user.have_password) {
              this.showAddPass = true
            }
          } else if (resp.data.error == "Lost connection to Redis server." || resp.data.error == "socket error on read socket") {
            if (document.referrer) {
              let status = confirm("Authorization temporary is unavailable. Go back to: " + document.referrer);
              if (status) {
                document.location.href = document.referrer;
              } else {
                this.gotoAuth();
              }
            } else {
              // в случае ошибки кикаем токен, если он имеется и редиректим на страницу логина
              this.gotoAuth();
            }
            //Если упал редис то не редиректим на авторизацию
          } else {
            // в случае ошибки кикаем токен, если он имеется и редиректим на страницу логина
            this.gotoAuth();
          }
        }).catch(err => {
          console.error(err)
          window.say.messageError(err);
          this.showLogin = true;
        })
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    },
    gotoAuth() {
      //удаляем токен
      if (store.token) {
        apiCookies.set("token", '', { expires: -1 });
        store.token = null;
      }
      if (process.env.NODE_ENV == 'production') {
        document.location.href = 'https://auth.skyservice.online/';
      } else {
        this.showLogin = true
      }
    },
    changeCompaniesList() { // Включить сортировку списка компаний
      if (this.searchString.length > 0) {
        this.searchString = '';
      }
      this.sortList = true;
      //window.say.messageWarn("Режим сортування компаній. Перемістіть компанії в зручному для Вас порядку, та натисніть кнопку зберегти");
    },
    saveCompaniesList() { // Сохранить последовательность компаний
      this.sortList = false
      const companiesListSort = this.companiesList.map(e => e.company_id);
      apiList.sortCompanies(companiesListSort)
        .then(json => {
          if (json.error) {
            window.say.messageError(...json.error)
          }
        });
    },
    cancelChanges() { // Отменить сортировку компаний
      this.sortList = false
      this.getData();
    },
    startSearch() {
      this.isSearchOpen = true;
      console.log('isSearchOpen', this.isSearchOpen)

      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    stopSearch() {
      this.searchString = '';
      this.isSearchOpen = false;
    },
    startStopSearch() {
      this.searchString = '';
      this.isSearchOpen = !this.isSearchOpen;
      if (this.isSearchOpen) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },
  },
  computed: {
    phrasesArray() {
      return [
        this.lang['preparingCompany1'],
        this.lang['preparingCompany2'],
        this.lang['preparingCompany3'],
        this.lang['preparingCompany4']
      ]
    },
    // Мова додатку
    lang() {
      if (this.form.lang != '' && this.form.lang != null) {
        window.lang = store.langs[this.form.lang]()
      }
      return window.lang;
    },
    w() {
      return store.window.width;
    },
    companiesList() {
      if (this.searchString) {
        return jsSearch(this.form.companies, this.searchString, 'like', ['company_name', 'company_description', 'company_id'],);
      } else {

        //Логіка яка створює список архівних компаній
        let newcompaniesList = [];
        // eslint-disable-next-line
        this.archivedCompanies = [];

        if (Array.isArray(this.form.user?.archive_companies) && this.form.user.archive_companies.length > 0) {
          this.form.companies.forEach((company) => {
            if (this.form.user.archive_companies.includes(company.company_id)) {
              this.archivedCompanies.push(company)
            } else {
              newcompaniesList.push(company)
            }
          });

          return newcompaniesList;
        } else {
          return this.form.companies;
        }
      }
    },
    searchText() {
      return this.lang["Search"] ? this.lang["Search"] : "";
    },
    dragOptions() { // опции для draggable
      return {
        animation: 250,
        disabled: !this.sortList,
        ghostClass: "ghost",
        delayOnTouchOnly: true, // задержка только для тача чтобы клик не срабатывал как драг
        delay: 250 // задержка
      };
    },
    isEmptySearch() {
      return this.searchString !== '' && this.companiesList.length === 0;
    }
  },
}
</script>

<style scoped>
button,
button.btn,
.btn {
  transition: none !important;
}

button:active {
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  border-color: transparent !important;
}

.flex-grow-1 {
  flex-grow: 1;
}

.companies {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
}

.blurred {
  filter: blur(5px) brightness(100%) contrast(100%);
  -webkit-filter: blur(5px) brightness(100%) contrast(100%);
  filter: blur(5px) brightness(100%) contrast(100%);
  height: 100vh;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

.d-flex {
  display: flex;
}

.p-absolute {
  position: absolute;
}

.hostApi {
  justify-content: center;
  align-items: center;
  gap: 5px
}

.hostApi input {
  margin: 0 !important;
}

.invites-div-desc {
  width: 85%;
  margin-top: 8px;
}

.company-invites-block {
  margin-bottom: 1rem;
  padding: 0 2px;
}

.noCompany-text {
  color: grey;
}

.icon-blocked {
  top: 5px;
  right: 5px;
  color: red;
  cursor: auto;
}

.company-icon {
  top: 5px;
  right: 5px;
  color: #647882;
  cursor: auto;
}

.text-div {
  float: left;
  margin-left: 10px;
  text-align: center;
  color: #525252;
}

.sortSave,
.rollBack {
  margin-right: 5px;
}

.sortSave {
  background-color: #00c279;
  border-color: #00c279;
}

.sortSave:hover {
  background-color: #00a265 !important;
  border-color: #00a265 !important;
}

.sortSave:active {
  background-color: #00a265 !important;
  border-color: #00a265 !important;
}

.rollBack {
  padding: 0px 7px;
  background-color: #f75656 !important;
  border-color: #f75656 !important;
}

.rollBack:hover {
  background-color: #d64545 !important;
  border-color: #d64545 !important;
}

.rollBack:active {
  background-color: #d64545 !important;
  border-color: #d64545 !important;
}

.img-div {
  float: right;
  width: 20px;
}

.img-arrow {
  width: 14px;
  transform: rotate(270deg);
  margin-bottom: 2px;
  color: #525252;
}

.img-arrow-down {
  width: 14px;
  transform: rotate(0deg);
  margin-bottom: 2px;
  color: #525252;
}

.img-arrow-up {
  width: 14px;
  transform: rotate(180deg);
  margin-bottom: 2px;
  color: #525252;
}

.buttonCard {
  justify-content: flex-end;
}

.enter-company {
  background-color: transparent;
  border: 1px solid #e7e7e7;
  cursor: pointer;
  padding-left: 15px;
  font-size: 14pt;
}

.btn-outline-primary:hover {
  background-color: white;
  color: inherit;
}

.btn-outline-primary:focus,
.btn-outline-primary:active {
  background-color: white !important;
  border: none !important;
  color: inherit;
}

.btn-outline-primary {
  border-color: white;
}

/*.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  border-color: #343a40;
}

.btn-outline-dark:hover,
.btn-outline-dark:active,
.btn-outline-dark:focus {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:hover .text-div,
.btn-outline-dark:active .text-div,
.btn-outline-dark:hover .text-div {
  color: #fff;
}*/

.enter-company:hover,
.enter-company:focus,
.enter-company:active {
  background: #f2f2f2 !important;
  border: 1px solid #e7e7e7 !important;
}

.btn-info,
.enter-company {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: right;
  border-radius: 20px;
  font-size: 14px;
  color: #3a484e;
  transition: background-color 0.3s ease;
}

.enter-company-blocked {
  display: none;
}

.blocked-text {
  text-align: center;
  color: #525252;
  font-weight: 600;
}

.p-style {
  color: #b7b6b6;
  font-size: 0.8rem;
}

.desc-div {
  width: 85%;
  margin-top: 8px;
}

.card {
  padding: 5px;
}

.company-block {
  display: grid !important;
  grid-template-columns: repeat(1, minmax(290px, 1fr));
  /* grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); */
  gap: 20px;
  align-items: stretch;
  margin-bottom: 10px;
}


@media (min-width: 750px) {
  .company-block {
    grid-template-columns: repeat(2, minmax(290px, 1fr));
  }
}

@media (min-width: 1120px) {
  .company-block {
    grid-template-columns: repeat(3, minmax(290px, 1fr));
  }
}

@media (min-width: 1490px) {
  .company-block {
    grid-template-columns: repeat(4, minmax(290px, 1fr));
  }
}

@media (min-width: 1941px) {
  .company-block {
    grid-template-columns: repeat(5, minmax(290px, 1fr));
  }
}

@media (min-width: 2261px) {
  .company-block {
    grid-template-columns: repeat(6, minmax(290px, 1fr));
  }
}

.pos-style {
  flex-direction: column;
  width: 100%;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  position: relative;
  height: 100%;
  box-shadow: 0 1px 12px rgba(0, 0, 0, .1);
  transition: box-shadow .2s ease, transform .2s ease, -webkit-box-shadow .2s ease, -webkit-transform .2s ease;
}

.pos-style.blocked {
  background-color: #f8d5d6;
}

.pos-style-developer {
  line-height: 1.2;
  min-height: 110px;
  padding: 15px;
  border-radius: 0.5rem;
  position: relative;
  cursor: pointer;
  /* width: 100%; */
  box-shadow: 0 1px 12px rgba(0, 0, 0, .1);
  background: #fffad6;
  border: 1px solid #dadada !important;
  transition: box-shadow .2s ease, transform .2s ease, -webkit-box-shadow .2s ease, -webkit-transform .2s ease;
}

@media (pointer: fine) {

  .pos-style:hover,
  .pos-style-developer:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, .2);
    transition: 0.3s ease-in-out;
  }
}

.clear-search {
  width: 46px;
  height: 46px;
  opacity: 0;
  right: 0;
  cursor: pointer;
  color: #c9c9c9;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  font-size: 16pt;
}

.clear-search.active {
  opacity: 1;
}

.h5-500 {
  opacity: 1;
  position: absolute;
  line-height: 1.7;
  font-weight: 500;
  transition: opacity 0.6s ease 0.25s;
  /* для появи: opacity 0s (тривалість анімації) ease 0.15s; (затримка) */
  margin-bottom: 0;
}

.h5-501 {
  opacity: 1;
  line-height: 1.7;
  font-weight: 500;
  transition: opacity 0.6s ease 0.25s;
  height: 38px;
  margin-bottom: 15px;
}

.h5-501::first-letter {
  text-transform: uppercase;
}


.h5-500.hidden {
  opacity: 0;
  transition: opacity 0.4s ease 0s;
  /* для зникнення: opacity 0s (тривалість анімації) ease 0s; (затримка) */
}

.alert-warning {
  border-color: #f5db89;
  background-color: #fff8e2;
  font-weight: 300;
  margin-left: -8px;
  margin-right: -8px;
}

.not-search-div {
  margin-top: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.not-search-div svg {
  margin-bottom: 10px;
}

.buttonStartComp {
  width: 220px;
  margin-right: 10px;
}

.logoDiv {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  padding-left: 3px;
  margin: 0 auto;
  font-size: 3rem;
  width: 3.5rem;
  color: green
}

.logoImg {
  height: 60px;
  width: 60px;
  border-radius: 12px;
  margin-right: 10px;
}

.companies-settings {
  display: flex;
  margin-left: auto;
  justify-content: flex-end;
  flex: 1;
  height: 38px;
}

.company-search {
  width: 46px;
  position: relative;
  overflow: hidden;
  top: 0;
  transition: width 0.5s ease, opacity 0.3s ease;
  margin-left: auto;
}

.company-search.active {
  width: calc(100%);
}

.search-icon {
  /* opacity: 0; */
  padding: 0.25rem 0.5rem;
  position: absolute;
  cursor: pointer;
  top: 0;
  bottom: 0;
  margin: auto;
  /* left: 15px; */
  transition: opacity 0.4s ease;
}

/* .search-icon.active {
  opacity: 1;
}

.search-icon.hidden {
  opacity: 0;
} */

.searchbutton.active {
  opacity: 1;
}

.searchbutton.hidden {
  opacity: 0;
}

.searchInput {
  width: 100%;
  border: none;
  margin-bottom: 0 !important;
  /* border: 1px solid #c8c8c8;
  border-radius: 15px; */
  background: transparent;
  padding-left: 46px;
  transform-origin: right;
  background-color: white;
}

/* .searchInput.active {
  opacity: 1;
  width: 100%;
  width: calc(100% - 86px); 
  transform: scaleX(1);
} */

/* .searchInput.hidden {
  opacity: 0;
  transform: scaleX(0);
  transform-origin: left;
} */

.company_h {
  font-weight: bold;
  font-size: 16px;
}

.company_h span {
  color: rgb(223, 223, 223);
  font-weight: bold;
}

.description,
.company_h {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}

.description input {
  background: transparent;
  border: 0;
  height: 20px;
  width: 100%;
  padding: 0 !important;
}

.cat-svg {
  height: 200px;
  margin-bottom: 2rem;
}

.invites-accept {
  border: 1px solid #dadada;
  background: #fffad6;
}

.dialog_newdocument {
  width: 100%;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
  text-align: center;
  padding: 30px 0 30px 0;
  margin-bottom: 15px;
  cursor: pointer;
}

.main-div {
  height: 100%;
  overflow-y: auto;
  padding: 95px 15px 70px 15px;
}

/* Всі iPhone з вирізом (X, XS, 11 Pro, 12 Mini, 13 Mini, XR, 11, 12, 12 Pro, 13, 13 Pro, 14, 14 Pro, 14 Plus, 14 Pro Max) */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
/* X, XS, 11 Pro, 12 Mini, 13 Mini */
(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3),
/* XS Max, 11 Pro Max */
(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
/* XR, 11 */
(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3),
/* 12 Pro Max, 13 Pro Max, 14 Plus */
(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3),
/* 12, 12 Pro, 13, 13 Pro, 14 */
(device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3),
/* 14 Pro, 15, 15 Pro, 16 */
(device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3),
/* 14 Pro Max, 15 Pro Max, 15 Plus, 16 Plus */
(device-width: 402px) and (device-height: 874px) and (-webkit-device-pixel-ratio: 3),
/* 16 Pro */
(device-width: 440px) and (device-height: 956px) and (-webkit-device-pixel-ratio: 3)
/* 16 Pro Max */
  {

  @media screen and (orientation: portrait) {

    .main-div {
      padding-bottom: 180px;
    }

    @supports (padding: env(safe-area-inset-top)) {
      .ios-class .main-div {
        padding-top: calc(env(safe-area-inset-top) + 75px) !important;
        padding-bottom: calc(env(safe-area-inset-top) + 60px) !important;
      }
    }
  }

  @media screen and (orientation: landscape) {
    @supports (padding: env(safe-area-inset-top)) {
      .ios-class .main-div {
        padding-bottom: calc(env(safe-area-inset-top) + 30px);
      }
    }
  }
}

.custom-container {
  position: relative;
  margin: 0 auto;
  /* padding: 0 10px; */
}

@media (min-width: 1450px) {
  .custom-container {
    /* max-width: 1400px; */
  }

  /* .company-block {
  grid-template-columns: repeat(3, minmax(350px, 1fr));
} */
}

.span-container {
  border-radius: 0.25rem;
  padding: 10px 10px 10px 0;
}

.add-company {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 1rem;
  font-weight: 500;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.add-company:hover {
  text-decoration: underline;
}

.ghost-container {
  margin-bottom: 1rem;
  flex-direction: column;
  align-items: center;
}

.ghost-text {
  padding-right: 10px;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

#person {
  /* background-color: #f8f8f8; */
  background-color: white;
}

@media screen and (max-width: 768px) {
  /* .company-search { */
  /* width: 0;
    position: absolute; */
  /* bottom: 40px;
  left: 500px; */
  /* top: 0;
    right: 90px; */
  /* width: calc(100% - 86px);  */
  /* } */

  .buttonStartComp {
    margin-bottom: 5px;
    margin-right: 0;
  }

  .btn.dropdown-toggle.btn-primary {
    max-width: 30vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ghost-container {
    padding-top: calc(110px + 1rem + 15px);
  }

  .ghost-text {
    padding-right: 0;
  }
}

.ghost {
  opacity: 0;
}

.blue-color {
  color: #007bff;
}

.sortbutton {
  border: none;
  cursor: pointer;
  font-size: 12pt;
  background: transparent;
}

.editbutton {
  border: none;
  cursor: pointer;
  font-size: 12pt;
  background: transparent;
  /* margin: 0 !important;
  padding: 0 !important; */
}

.sortbutton svg {
  color: #106090;
}

.closeStartDescription {
  top: 2px;
  right: 0;
  color: #856405;
  cursor: pointer;
  border: none;
  background: transparent;
}

.sortedMode {
  opacity: 0.6;
}

.sortedIcon {
  width: 60px;
  height: 60px;
  background: rgb(193 193 193 / 60%);
  top: calc(50% - 50px);
  border-radius: 50%;
  left: calc(50% - 30px);
}

.icon-red {
  color: red;
  font-size: 16px;
  margin-right: 5px;
}

.cancel-button {
  border: 0;
  background: transparent;
}

.form-control {
  /* border-radius: 0 !important; */
}

.developer-box {
  padding-top: 15px;
}
</style>
<style>
.dropdown-menu {
  -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.dropdown-menu li a:hover {
  color: white;
  background: #007AFF;
}

.dropdown-toggle-split {
  border-left: 1px solid #eaeaea !important;
}
</style>
